import { BOOKING_GA_CATEGORIES, BookingPathKeys } from '../../paths';

export const SELECT_PATIENT_STRINGS = {
    PageTitle: 'Zocdoc | Booking | Patient',
    WhoWillBeSeeingTheDoctor: 'Who will be seeing the doctor?',
    MyNameIndicator: '(Me)',
    SomeoneElse: 'Someone else',
};

export const SELECT_PATIENT_GA_CATEGORY =
    BOOKING_GA_CATEGORIES[BookingPathKeys.selectPatientPath];
export const GaActionText = {
    trackFemaleGenderFieldSelect: 'New Sub-Patient Female Gender Field Select',
    trackMaleGenderFieldSelect: 'New Sub-Patient Male Gender Field Select',
    trackIsLegalGuardianFieldSelect:
        'New Sub-Patient Is Legal Guardian Field Select',
    trackIsNotLegalGuardianFieldSelect:
        'New Sub-Patient Is Not Legal Guardian Field Select',
    trackNewSubPatientEmailFieldSelect: 'New Sub-Patient Email Field Select',
    trackNewSubPatientFirstNameFieldSelect:
        'New Sub-Patient First Name Field Select',
    trackNewSubPatientLastNameFieldSelect:
        'New Sub-Patient Last Name Field Select',
    trackNewSubPatientDayDOBFieldSelect: 'New Sub-Patient Day DOB Field Select',
    trackNewSubPatientMonthDOBFieldSelect:
        'New Sub-Patient Month DOB Field Select',
    trackNewSubPatientYearDOBFieldSelect:
        'New Sub-Patient Year DOB Field Select',
    trackClickContinue: 'Click Continue',
    trackMePatientFieldSelect: 'Me Patient Field Select',
    trackNewSubPatientFieldSelect: 'New Sub-Patient Field Select',
    trackExistingSubPatientFieldSelect: 'Existing Sub-Patient Field Select',
};
